'use client'
import { Button } from '@/components/Button'
import { I18NText } from '@/components/I18NText'
import { Paragraph } from '@/components/Typography/Paragraph'
import { useRouter } from '@/lib/useRouter'
import { startAuthentication } from '@simplewebauthn/browser'
import { useMutation } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'
import { getAuthenticationOptions, verifyLogin } from '../_lib/login'

export const PasskeyLogin = () => {
	const router = useRouter()
	const form = useForm()

	const verifyMutation = useMutation({
		mutationFn: async (
			variables: Awaited<ReturnType<typeof getAuthenticationOptions>>,
		) => {
			const { options, challengeId } = variables
			const authResponse = await startAuthentication({ optionsJSON: options })
			return verifyLogin(authResponse, challengeId)
		},
		onSuccess: (token) => router.push(`/authenticated?token=${token}`),
	})

	const optionsMutation = useMutation({
		mutationFn: () => getAuthenticationOptions(),
		onSuccess: (result) => {
			verifyMutation.mutate(result)
		},
	})

	async function onSubmit() {
		optionsMutation.mutate()
	}

	const error = optionsMutation.error || verifyMutation.error

	return (
		<form onSubmit={form.handleSubmit(onSubmit)}>
			<Button
				type="submit"
				variant="tertiary"
				className="w-full"
				loading={optionsMutation.isPending || verifyMutation.isPending}
			>
				<I18NText text="userSettings.authentication.signInWithPasskey" />
			</Button>
			{error && (
				<Paragraph className="text-center text-red-700">
					{error.message}
				</Paragraph>
			)}
		</form>
	)
}
